import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityAwsCostRecommendationPluginCard } from '@internal/plugin-aws-finops-frontend';

export const CostOptimizationCard = () => {
  const { entity } = useEntity();
  const accountId = entity?.metadata?.annotations!['amazonaws.com/account-id'];

  return <EntityAwsCostRecommendationPluginCard accountId={accountId} />;
};
